module.exports = __webpack_public_path__ + "static/img/14.d1cd2437.jpg";